var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: 800,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        switchFullscreen: "",
        cancelText: "关闭",
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: { model: _vm.model, rules: _vm.validatorRules },
            },
            [
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "serialNo",
                    label: "设备编号",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入设备编号" },
                    model: {
                      value: _vm.model.serialNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "serialNo", $$v)
                      },
                      expression: "model.serialNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "cameraName",
                    label: "安装位置",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入安装位置" },
                    model: {
                      value: _vm.model.cameraName,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "cameraName", $$v)
                      },
                      expression: "model.cameraName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "actionArea",
                    label: "学校名称",
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入学校名称" },
                    model: {
                      value: _vm.model.actionArea,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "actionArea", $$v)
                      },
                      expression: "model.actionArea",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    prop: "areaType",
                    label: "位置类型",
                  },
                },
                [
                  _c("a-input-number", {
                    attrs: {
                      placeholder: "请输入位置类型(0=默认、1=入校、2=出校)",
                    },
                    model: {
                      value: _vm.model.areaType,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "areaType", $$v)
                      },
                      expression: "model.areaType",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }